// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Bn9F","title":"AfterFrontImage_title__3FNE6"};